import { api } from "@/client/api"

export default {
    validateEmail(email, providerKey) {
        return api.post(`/providers/${providerKey}/validateEmail`,{
            email
        })
    }
}
